import { ProjectExportDataService } from './project-export-data.service';
import { StringUtils } from '@shared/util/string-utils';
import { ProjectUtils } from '../../project/util/project-utils';
import { UserModel } from '@user/model/user.model';
import { AlertHelper } from '@shared/alert/alert.helper';
import { FileUtils } from '@shared/util/file-utils';
import { Log } from '@shared/debug/log';
import { ProjectVO } from '../../../model/vo/project.vo';
import { StringValueInLocalesVO } from '../../article/model/vo/property.vo';
import { OverlayService } from '@shared/overlay/overlay.service';
import { Injectable } from '@angular/core';
import { LoadProjectService } from '../../../service/load-project.service';
import { ProjectModelService } from '@project/service/project-model.service';
import { ProjectUserModel } from '../../../model/project-user.model';
import { OverlayBackground } from '@shared/overlay/overlay.type';
import { lastValueFrom } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ImportWspManager {

  constructor(
    private userModel: UserModel,
    private alertHelper: AlertHelper,
    private projectModelService: ProjectModelService,
    private projectExportDataService: ProjectExportDataService,
    private overlayService: OverlayService,
    private loadProjectService: LoadProjectService,
    private projectUserModel: ProjectUserModel,
  ) {
  }

  public async importWspProject(): Promise<void> {
    let file: File;
    try {
      file = await FileUtils.loadFile('.wsp');
    } catch (error) {
      FileUtils.handleFileLoadingError(error, this.alertHelper);
      return;
    }

    if (!file) {
      return;
    }

    try {
      await this.overlayService.doWithOverlay(async () => {
        await this.projectModelService.clearCurrentProject();

        const complexProjectVO = await lastValueFrom(this.projectExportDataService.importProjectFromWSPFile(file as any));
        if (complexProjectVO) {
          complexProjectVO.isWSPImportedProject = true;
          if (complexProjectVO.project) {
            const project: ProjectVO = complexProjectVO.project;
            project.isWSPImportedProject = true;
            if (!project.projectComment) {
              // Support of old projects when it was possible to create project without project comment
              project.projectComment = new StringValueInLocalesVO();
              project.projectComment.localizedValues = [];
            }
          }
        }
        if (complexProjectVO && StringUtils.isEmpty(ProjectUtils.getVersionDisplayString(complexProjectVO.project, false))
          && this.userModel.user && this.userModel.user.isRegisteredUserAccount()) {
          // only in case real user is logged in, we apply his default project version
          ProjectUtils.setInitialVersionDisplayString(complexProjectVO.project, this.projectUserModel.projectOptionDefs);
        }
        await this.loadProjectService.loadProjectModel(complexProjectVO);
      }, OverlayBackground.color);
      await this.loadProjectService.handleCorruptedArticles();
    } catch (error) {
      Log.error('Import failed: ', error);
      this.alertHelper.showError('importProject.title.import_failed', 'importProject.message.import_failed');
    }
  }
}
